module.exports = __webpack_public_path__ + "static/media/service-center-perawatan-perbaikan-mobil-menyeluruh.c99b908c.jpg";